import './scss/pages/single-events.scss';
import SetSlider from './js/front/single-post-slider';

window.addEventListener( 'DOMContentLoaded', () => {

	const sliders = document.querySelectorAll( '.single-events-gallery .wombat-slider-container' );

	if ( sliders.length > 0 ) {

		sliders.forEach( slider => {

			const sliderSettings = new SetSlider( slider );
			sliderSettings.initSliderSettings();

		} )

	}

} );

